import { render, staticRenderFns } from "./PictureFallback.vue?vue&type=template&id=20cce7d7&"
import script from "./PictureFallback.vue?vue&type=script&lang=js&"
export * from "./PictureFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports